module.exports = __webpack_public_path__ + "img/adobe-vs-magento-img.f2f4a3f6.webp";